import type { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";

import { logout } from "../../features/auth/auth.slice";
import { store } from "../store";

/**
 * Log a warning and show a toast!
 */
const renderValidationErrors = (errors: { [key: string]: string }) => {
  const errorsForUi: string[] = [];

  for (const key in errors) {
    if (Object.prototype.hasOwnProperty.call(errors, key)) {
      const element = errors[key];

      errorsForUi.push(element);
    }
  }

  return errorsForUi.length > 0 ? errorsForUi : null;
};

export const RtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      if (action?.payload?.status === 402) {
        store.dispatch(logout());
      }
    }

    return next(action);
  };
